/* jshint esversion: 6 */
import * as constants from 'app/redux/constants.js';
import { defaultState } from 'app/redux/defaultState.js';
import Utilities from 'app/utility/Utilities.js';
import FilterModule from 'app/mixins/FilterModule.js';
import SortModule from 'app/mixins/SortModule.js';


export const subaccounts = (state = defaultState.subaccounts, action) => {
    let nextState = Utilities.deepClone(state),
        i = 0,
        matched = -1,
        subaccounts = [],
        // The views render filteredList whenever a search is active, so EVERY case that
        // rewrites list has to re-derive it or the change is invisible while filtering:
        // FilterModule returns the same row objects, not copies, so a filtered view
        // otherwise keeps showing a row that has been replaced or removed.
        reapplyFilter = () => {
            if (nextState.filter.key !== undefined) {
                nextState.filteredList = FilterModule(nextState.list, nextState.filter.key, nextState.filter.value, nextState.filter.exact);
            }
        },
        // Pending invitations are keyed by email — one per address, matching the
        // UNIQUE pi_emailHash the server enforces.
        isSamePending = (row, payload) => (row.pending === true && payload.pending === true && row.email === payload.email);

    switch (action.type) {
        case constants.UTILITIES_FILTER_STORE:
            if (action.store === 'subaccounts') {
                nextState.filter = {
                    key: action.filter,
                    value: action.value,
                    exact: action.exact
                };
                nextState.filteredList = FilterModule(nextState.list, action.filter, action.value, action.exact);
            }
            break;

        case constants.UTILITIES_SORT_STORE:
            if (action.store === 'subaccounts') {
                nextState.sort = {
                    key: action.key,
                    direction: action.direction
                };
                nextState.list = SortModule(nextState.list, action.key, action.direction);
                if (nextState.filteredList.length > 0) {
                    nextState.filteredList = SortModule(nextState.filteredList, action.key, action.direction);
                }
            }
            break;

		case constants.UTILITIES_CLEAR_FILTER:
			if (action.store === 'subaccounts') {
                nextState.filter = {};
				nextState.filteredList = [];
			}
			break;

        case constants.SUBACCOUNT_LIST:
            if (action.status === constants.STATE_SUCCESS) {
                nextState.list = action.payload;
            } else {
                // reset the list since we may be grabbing a different type
                // of subaccount (agent vs. client)
                nextState.list = [];
            }
            reapplyFilter();
            break;

        case constants.SUBACCOUNT_SHOW:
        case constants.SUBACCOUNT_UPDATE:
            if (action.status === constants.STATE_SUCCESS) {
                for (i = 0; i < nextState.list.length; ++i) {
                    if (parseInt(nextState.list[i].id, 10) === parseInt(action.payload.id, 10)) {
                        nextState.list[i] = action.payload;
                        break;
                    }
                }
                reapplyFilter();
            }
            break;

        case constants.SUBACCOUNT_DELETE:
            if (action.status === constants.STATE_SUCCESS) {
                for (i = 0; i < nextState.list.length; ++i) {
                    if (parseInt(nextState.list[i].id, 10) !== parseInt(action.payload.id, 10)) {
                        subaccounts.push(nextState.list[i]);
                    }
                }
                nextState.list = subaccounts;
                reapplyFilter();
            }
            break;

        case constants.SUBACCOUNT_CREATE:
            if (action.status === constants.STATE_SUCCESS) {
                // Re-inviting an address that already has an outstanding invitation
                // replaces the record server-side (PublisherInvite::issue deletes by
                // email hash first), so replace the row rather than adding a twin.
                matched = nextState.list.findIndex((row) => isSamePending(row, action.payload));
                if (matched === -1) {
                    nextState.list.push(action.payload);
                } else {
                    nextState.list[matched] = action.payload;
                }
                reapplyFilter();
            }
            break;

        // Pending invitations carry no id (no Publisher row exists yet), so they're
        // matched by email — matching on id would hit every pending row at once.
        case constants.SUBACCOUNT_INVITE_RESEND:
            if (action.status === constants.STATE_SUCCESS) {
                for (i = 0; i < nextState.list.length; ++i) {
                    if (isSamePending(nextState.list[i], action.payload)) {
                        // re-issuing moves the verify window, so the row is replaced
                        // rather than left displaying the old expiry
                        nextState.list[i] = action.payload;
                        break;
                    }
                }
                reapplyFilter();
            }
            break;

        case constants.SUBACCOUNT_INVITE_REVOKE:
            if (action.status === constants.STATE_SUCCESS) {
                for (i = 0; i < nextState.list.length; ++i) {
                    if (isSamePending(nextState.list[i], action.payload)) {
                        continue;
                    }
                    subaccounts.push(nextState.list[i]);
                }
                nextState.list = subaccounts;
                reapplyFilter();
            }
            break;

        default:
            break;

    }

    return nextState;
};
